import { useTranslations } from 'contexts/Translation'
import { HeaderBreadcrumbs, Spinner } from 'components'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams, useHistory } from 'react-router-dom'
import { MockupAdvancedView } from 'domains/Mockup/components'
import { EditOutlined } from '@ant-design/icons'
import { Button } from '@qonsoll/react-design'

const MockupShow = (props) => {
  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const params = useParams()

  // [COMPONENT_STATE_HOOKS]

  // [COMPUTED_PROPERTIES]
  const headingProps = {
    title: t('Mockup show'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }
  const { mockupId } = params

  // [HANDLERS]
  const handleBackButtonClick = () => history.goBack()

  return (
    <PageWrapper
      action={
        <Button
          icon={<EditOutlined />}
          onClick={() => history.push(`${mockupId}/edit`)}>
          {t('Edit')}
        </Button>
      }
      headingProps={headingProps}>
      <Row noGutters>
        <Col>
          <MockupAdvancedView />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default MockupShow
